import { Injectable } from '@angular/core';

@Injectable()
export class SharedService {

  constructor() { }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/Documentos/Angular/14-AdminPro/src/app/services/shared/shared.service.ts